import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=08be78a7&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=08be78a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be78a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08be78a7')) {
      api.createRecord('08be78a7', component.options)
    } else {
      api.reload('08be78a7', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=08be78a7&scoped=true&", function () {
      api.rerender('08be78a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Things/Index.vue"
export default component.exports